import { t } from '@transifex/native';

import { show } from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';

export async function createGoal(
	organizationId: number,
	userId: number,
	goal: models.userGoal.UserGoal
) {
	const [request] = await create<
		models.userGoal.UserGoal,
		models.userGoal.UserGoal
	>(endpoints.UserGoals.Create(organizationId, userId), goal);

	if (!request.ok) {
		show({
			title: t(`Failed to create goal`),
		});

		return;
	}

	show(
		{
			title: t(`Goal created`),
		},
		200
	);
}

export async function updateGoal(
	organizationId: number,
	goal: models.userGoal.UserGoal
) {
	const request = await sdk.patch(
		endpoints.UserGoals.Update(organizationId, goal.id),
		{},
		goal
	);

	if (!request.ok) {
		show({
			title: t(`Failed trying to update goal`),
		});

		return false;
	}

	show({
		title: t(`Goal updated`),
	});

	return true;
}

export async function removeGoal(
	organizationId: number,
	goal: models.userGoal.UserGoal
) {
	const request = await sdk.destroy(
		endpoints.UserGoals.Delete(organizationId, goal.id),
		{},
		{}
	);

	if (!request.ok) {
		show({
			title: t(`Could not remove goal`),
		});

		return false;
	}

	show(
		{
			title: t(`Successfully removed goal`),
		},
		200
	);

	return true;
}
